import type { JwtApiAppRouter } from '@kindo/api';
import { createTRPCProxyClient, httpLink, HTTPLinkOptions } from '@trpc/client';
import { createTRPCNext } from '@trpc/next';
import type { inferRouterOutputs } from '@trpc/server';

import { TRPC_URL } from '~/constants';

type FetchParameters = Parameters<Required<HTTPLinkOptions>['fetch']>;

const fetchWithCredentials = (
  url: FetchParameters[0],
  options: FetchParameters[1]
) =>
  fetch(url, {
    ...options,
    credentials: 'include' // This ensures cookies are included with requests
  });

// Old TRPC client
export const trpc = createTRPCProxyClient<JwtApiAppRouter>({
  links: [
    httpLink({
      url: TRPC_URL,
      fetch: fetchWithCredentials
    })
  ]
});

// TRPC client integrated with Next, use this one moving forward
// https://trpc.io/docs/client/nextjs/setup
// https://trpc.io/docs/client/react
export const nextTrpc = createTRPCNext<JwtApiAppRouter>({
  config() {
    return {
      links: [
        httpLink({
          /**
           * If we want to use SSR, we'll need to use the server's full URL
           * @link https://trpc.io/docs/ssr
           * */
          url: TRPC_URL,
          fetch: fetchWithCredentials
        })
      ]
    };
  },
  /**
   * @link https://trpc.io/docs/ssr
   * */
  ssr: false
});

export type RouterOutput = inferRouterOutputs<JwtApiAppRouter>;

export type TRPC = typeof trpc;
